import { useParams } from "react-router-dom";
import { StateInfoList } from "./StateInfoList";

/** Shows the starting parameters in `Adm`. Those are set in the URL. */
export function AdmStateInfo(): JSX.Element {
  const { variant, numbers } = useParams();

  return (
    <StateInfoList
      rows={[
        ["variant", variant],
        ["numbers", numbers],
      ]}
    />
  );
}
